export function getYoutubeId(url: string): string | null {
  try {
    const parsed = new URL(url);
    if (parsed.hostname.includes('youtu.be')) {
      return parsed.pathname.replace('/', '') || null;
    }
    const watchId = parsed.searchParams.get('v');
    if (watchId) return watchId;
    const match = parsed.pathname.match(/\/embed\/([^/?]+)/);
    return match ? match[1] : null;
  } catch {
    return null;
  }
}
